import { Box, Grid, GridItem, Icon, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import {
  FaUserCheck,
  FaCar,
  FaBuilding,
  FaQuestionCircle,
  FaCog,
} from "react-icons/fa";
import BreadCrumbMaker from "../../components/BreadCrumbMaker";
import { useContext } from "react";
import { AuthContext } from "../../providers/AuthValidationLayer";

const VerificationCenter = () => {
  const { hasPermission } = useContext(AuthContext);
  
  const cardData = [
    {
      id: 1,
      title: "Driver Approvals",
      icon: FaUserCheck,
      link: "/verification/driver-approvals",
      bgColor: "#E7EDFF",
      color: "#396AFF",
      permission: { heading: "Verification Center", subHeading: "Driver Approvals" },
    },
    {
      id: 2,
      title: "Vehicle Approvals",
      icon: FaCar,
      link: "/verification/vehicle-approvals",
      bgColor: "#FFF5D9",
      color: "#FFBB38",
      permission: { heading: "Verification Center", subHeading: "Vehicle Approvals" },
    },
    {
      id: 3,
      title: "Vendor Approvals",
      icon: FaBuilding,
      link: "/verification/vendor-approvals",
      bgColor: "#FFE0EB",
      color: "#FF82AC",
      permission: { heading: "Verification Center", subHeading: "Vendor Approvals" },
    },
    {
      id: 4,
      title: "Awaiting Clarification",
      icon: FaQuestionCircle,
      link: "/verification/awaiting-clarification",
      bgColor: "#DCFAF8",
      color: "#00B69B",
      permission: { heading: "Verification Center", subHeading: "Awaiting Clarification" },
    },
    {
      id: 5,
      title: "Vendor Onboarding Config",
      icon: FaCog,
      link: "/verification/vendor-onboarding-config",
      bgColor: "#ffe9e2",
      color: "#ff8542",
      permission: { heading: "Verification Center", subHeading: "Vendor Onboarding Config" },
    },
  ];

  return (
    <Box px={4} py={6}>
      <BreadCrumbMaker items={[{ link: "#", title: "Verification Center", on: true }]} />
      <Grid
        templateColumns={{
          base: "repeat(1, 1fr)",
          sm: "repeat(2, 1fr)",
          md: "repeat(3, 1fr)",
        }}
        gap={6}
      >
        {cardData
          .filter((card) =>
            hasPermission(
              card.permission.heading,
              card.permission.subHeading,
              "GET",
            ),
          )
          .map((card) => (
            <GridItem key={card.id}>
              <Link to={card.link}>
                <Box
                  bg="white"
                  p={4}
                  textAlign="center"
                  display="flex"
                  flexDirection="row"
                  justifyContent="flex-start"
                  alignItems="center"
                  h="120px"
                  gap={2}
                  borderRadius="3xl"
                  border="1px solid #D0D5DD"
                  borderColor="gray.200"
                  transition="all 0.2s ease"
                  _hover={{
                    borderColor: "blue.400",
                    boxShadow: "md",
                    transform: "translateY(-2px)",
                  }}
                >
                  <Box
                    bg={card.bgColor}
                    w={18}
                    h={18}
                    p={30}
                    mx={4}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    borderRadius="full"
                  >
                    <Icon as={card.icon} boxSize={6} color={card.color} />
                  </Box>
                  <Text fontSize="16px" fontWeight="semibold" color="gray.500">
                    {card.title}
                  </Text>
                </Box>
              </Link>
            </GridItem>
          ))}
      </Grid>
    </Box>
  );
};

export default VerificationCenter;
